import { render, staticRenderFns } from "./UnauthorizedZoom.vue?vue&type=template&id=5529463e"
import script from "./UnauthorizedZoom.vue?vue&type=script&lang=js"
export * from "./UnauthorizedZoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports